import PropTypes from 'prop-types'

import { formatDate } from '@/utils/formatters'

/**
 * Displays instructor certifications with expiration dates
 * @param {Object} props
 * @param {Object} props.user - User object containing instructor certification fields
 * @param {string} props.user.rescuexInstructorNumber
 * @param {string} props.user.rescuexInstructorExpiration
 * @param {string} props.user.rescueReadyInstructorNumber
 * @param {string} props.user.rescueReadyInstructorExpiration
 * @param {string} props.user.surfaceRescueInstructorNumber
 * @param {string} props.user.surfaceRescueInstructorExpiration
 */
export const InstructorCertifications = ({ user }) => {
  const hasCertifications =
    user?.rescuexInstructorNumber ||
    user?.rescueReadyInstructorNumber ||
    user?.surfaceRescueInstructorNumber

  if (!hasCertifications) {
    return (
      <div className="flex flex-col gap-3 rounded-lg border-1 p-4">
        <span className="text-sm font-semibold">Instructor Certifications</span>
        <span className="text-muted-foreground text-xs italic">
          No instructor certifications issued yet
        </span>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3 rounded-lg border-1 p-4">
      <span className="text-sm font-semibold">Instructor Certifications</span>
      <div className="text-muted-foreground flex flex-col gap-2 text-sm">
        {user.rescuexInstructorNumber && (
          <div>
            <span className="font-medium">RescueX Instructor:</span> {user.rescuexInstructorNumber}
            {user.rescuexInstructorExpiration && (
              <span className="text-muted-foreground ml-2 text-xs">
                (Expires: {formatDate(user.rescuexInstructorExpiration)})
              </span>
            )}
          </div>
        )}
        {user.rescueReadyInstructorNumber && (
          <div>
            <span className="font-medium">Rescue Ready Instructor:</span>{' '}
            {user.rescueReadyInstructorNumber}
            {user.rescueReadyInstructorExpiration && (
              <span className="text-muted-foreground ml-2 text-xs">
                (Expires: {formatDate(user.rescueReadyInstructorExpiration)})
              </span>
            )}
          </div>
        )}
        {user.surfaceRescueInstructorNumber && (
          <div>
            <span className="font-medium">Surface Rescue Instructor:</span>{' '}
            {user.surfaceRescueInstructorNumber}
            {user.surfaceRescueInstructorExpiration && (
              <span className="text-muted-foreground ml-2 text-xs">
                (Expires: {formatDate(user.surfaceRescueInstructorExpiration)})
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

InstructorCertifications.propTypes = {
  user: PropTypes.shape({
    rescuexInstructorNumber: PropTypes.string,
    rescuexInstructorExpiration: PropTypes.string,
    rescueReadyInstructorNumber: PropTypes.string,
    rescueReadyInstructorExpiration: PropTypes.string,
    surfaceRescueInstructorNumber: PropTypes.string,
    surfaceRescueInstructorExpiration: PropTypes.string,
  }),
}
